var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartInboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5662 0.175122C15.8818 0.393875 16.0474 0.772006 15.9881 1.15014L13.988 14.1503C13.9412 14.4535 13.7568 14.7191 13.488 14.8691C13.2193 15.0191 12.8974 15.0378 12.613 14.9191L8.87546 13.3659L6.7348 15.6816C6.45667 15.9847 6.01917 16.0847 5.63479 15.9347C5.25041 15.7847 5.0004 15.4129 5.0004 15.0003V12.3878C5.0004 12.2628 5.04728 12.1441 5.13165 12.0503L10.3692 6.33772C10.5505 6.14084 10.5442 5.83771 10.3567 5.65021C10.1692 5.4627 9.8661 5.4502 9.66922 5.62833L3.31288 11.2753L0.553459 9.89402C0.222204 9.72839 0.00970063 9.39714 0.000325491 9.02838C-0.00904965 8.65963 0.184703 8.31587 0.503458 8.13149L14.5037 0.131371C14.8381 -0.0592564 15.2506 -0.0405061 15.5662 0.175122Z",
    fill: "#DDEB9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartInboxIcon);
export default __webpack_public_path__ + "static/media/smart-inbox-icon.288c66afea416a0880c214e44757080d.svg";
export { ForwardRef as ReactComponent };